export enum CompensationUnit {
    percent = 'percent',
    usd = 'usd',
}

export const compensationUnitLabels = {
    percent: '%',
    usd: '$',
};
